<template>
  <div class="app-wrapper">
    <main class="main-content">
      <section class="welcome-card">
        <div class="brand-mark">T</div>
        <p class="eyebrow">THXily</p>
        <h1 class="welcome-title">Preparing your screen</h1>
        <p class="welcome-text">{{ statusText }}</p>

        <div class="loader" aria-hidden="true">
          <span class="loader-ring"></span>
          <span class="loader-ring loader-ring--delay"></span>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import store from "../store";

export default {
  name: 'WelcomeView',
  data() {
    return {
      statusText: 'Checking your session and routing to the right page.',
      redirectTimer: null,
    };
  },
  mounted() {
    const target = store.getters.isAuthenticated ? "/menu" : "/login";
    this.statusText = target === "/menu"
      ? 'Session found. Moving to the menu.'
      : 'No session found. Moving to the login screen.';
    this.redirectTimer = window.setTimeout(() => {
      this.$router.replace(target);
    }, 320);
  },
  beforeUnmount() {
    if (this.redirectTimer) {
      window.clearTimeout(this.redirectTimer);
    }
  },
  components: {}
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@400;500;700&display=swap');

.app-wrapper {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background:
    radial-gradient(circle at top left, rgba(59, 130, 246, 0.16), transparent 30%),
    radial-gradient(circle at bottom right, rgba(124, 92, 252, 0.12), transparent 24%),
    linear-gradient(180deg, #e7ecf4 0%, #dde2ec 100%);
  font-family: 'Noto Sans JP', 'Segoe UI', sans-serif;
}

.main-content {
  width: 100%;
  max-width: 560px;
  padding: 32px 24px;
}

.welcome-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 14px;
  padding: 40px 28px 36px;
  border-radius: 24px;
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid rgba(226, 232, 240, 0.85);
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.12);
  backdrop-filter: blur(10px);
}

.brand-mark {
  width: 56px;
  height: 56px;
  border-radius: 18px;
  background: linear-gradient(135deg, #4f8ef7, #7c5cfc);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.3rem;
  font-weight: 800;
  color: #fff;
  box-shadow: 0 12px 24px rgba(79, 142, 247, 0.25);
}

.eyebrow {
  margin: 0;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: #64748b;
}

.welcome-title {
  margin: 0;
  font-size: 1.45rem;
  line-height: 1.4;
  color: #1e293b;
}

.welcome-text {
  margin: 0;
  color: #475569;
  font-size: 0.95rem;
  line-height: 1.8;
}

.loader {
  position: relative;
  width: 72px;
  height: 72px;
  margin-top: 6px;
}

.loader-ring {
  position: absolute;
  inset: 0;
  border-radius: 50%;
  border: 3px solid rgba(59, 130, 246, 0.18);
  border-top-color: #3b82f6;
  animation: spin 1s linear infinite;
}

.loader-ring--delay {
  inset: 12px;
  border-top-color: #7c5cfc;
  animation-duration: 1.4s;
  animation-direction: reverse;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

@media (max-width: 640px) {
  .main-content {
    padding: 20px 16px;
  }

  .welcome-card {
    padding: 32px 18px 28px;
    border-radius: 20px;
  }
}
</style>
